import CountUp from 'components/BinanceLanding/CountUp';
import classes from './HomeNumbers.module.scss';


// С бэкенда приходит строка вида «70 преподавателей»:
// число отделяем, чтобы оно набегало при появлении блока.
const splitValue = (title = '') => {
  const [ first, ...rest ] = String(title).trim().split(' ');
  const digits = first.replace(/\D/g, '');

  if (!digits) return { value: null, label: title };
  return { value: Number(digits), label: rest.join(' ') };
};

const HomeNumbers = ({ data }) => {
  if (!data?.length) return null;

  return (
    <section className={classes.numbers}>
      <div className={classes.container}>
        <div className={`${classes.grid} ${data.length < 2 ? classes.gridSingle : ''}`}>
          {data.map((item, i) => {
            const { value, label } = splitValue(item?.title);

            return (
              <div
                className={classes.cardWrap}
                key={item?.title ?? i}
                data-aos="fade-up"
                data-aos-delay={(i % 2) * 100}
              >
                <div className={classes.card}>
                  <p className={classes.value}>
                    {value === null ? label : <><CountUp value={value} suffix="" /> {label}</>}
                  </p>
                  <p className={classes.caption}>{item?.thesis}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeNumbers;
